import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  flagDatas: [],
  allFlagDatas: [],
  totalPages: 0,
  totalRecords: 0,
  flagData: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_29: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_FlagDatas(state, flagDatas) {
    state.flagDatas = flagDatas.items;
    state.totalPages = flagDatas.totalPages;
    state.totalRecords = flagDatas?.totalRecords ?? 0;
  },
  SET_AllFlagDatas(state, flagDatas) {
    state.allFlagDatas = flagDatas;
  },
  SET_FlagData(state, flagData) {
    state.flagData = flagData;
  },
};
const actions = {
  errorFlagData({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllFlagDatas({ commit, dispatch, rootState }) {
    return apiClient
      .get('/FlagDatas/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllFlagDatas', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorFlagData', error);
      });
  },
  getFlagDatasWithPagination({ commit, dispatch, rootState }, { pageNumber, pageSize, title }) {
    var url = '/FlagDatas/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_FlagDatas', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorFlagData', error);
      });
  },
  addFlagData({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/FlagDatas', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorFlagData', error);
      });
  },
  getFlagData({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/FlagDatas/ById?flagDataId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_FlagData', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorFlagData', error);
      });
  },
  editFlagData({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/FlagDatas/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorFlagData', error);
      });
  },
  deleteFlagData({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/FlagDatas/Remove?flagDataId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorFlagData', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
